import React from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Link, Typography } from "@mui/material";
import "../../../utils/styles/Politicas/9001/9001Styles.scss";
import poster1 from "../../../utils/img/Politicas/calidad1.jpg";
import Image from "../../../utils/img/Home/Nosotros/Nosotros03.jpg";
import CircleIcon from "@mui/icons-material/FiberManualRecord";

const Politica9001 = () => {
  return (
    <Box
      style={{
        position: "relative",
        marginTop: "-20px",
        zIndex: "1",
        paddingBottom: "20px",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box className="PoliticasPortada">
        <img src={poster1} alt="" />
      </Box>
      <Box style={{ padding: "82px 30px" }}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <Box className="PoliticasInformacion">
              <Box textAlign="center">
                <Typography className="TittlePolitica9001">
                  Política de Calidad
                </Typography>
              </Box>
              <Box>
                <Box>
                  <Typography className="TextPolitica9001Part1">
                    TRANSMDICAS S.R.L. es una empresa de Transporte por
                    Carretera de Materiales Peligrosos y Carga en General,
                    presente en la Industria y Minería; conscientes de nuestra
                    responsabilidad, nos comprometemos a:
                  </Typography>
                </Box>
                {/* <Box>
                  <Typography className="TextPolitica9001Part2">
                    Siendo conscientes de nuestra responsabilidad, nos
                    comprometemos a:
                  </Typography>
                </Box> */}
                <Box style={{ marginBottom: "20px" }}>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001Part3">
                      Mantener el seguimiento, medición y evaluación periódica del cumplimiento 
                      de los Objetivos del Sistema de Gestión de Calidad, siendo coherentes con la
                      Política y el Contexto de la Organización.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001">
                       Identificar, evaluar y gestionar los riesgos y oportunidades asociados a
                       nuestros procesos, con el fin de mejorar el desempeño de nuestro Sistema de
                       Gestión de Calidad.

                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001">
                      Garantizar que nuestros trabajadores sean competentes, estén debidamente
                      capacitados y sean conscientes de la importancia de su contribución al
                      cumplimiento de los objetivos de calidad.

                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001">
                      Satisfacer adecuadamente las expectativas de nuestros clientes,
                      anticipándonos a sus necesidades, brindando nuestros servicios con
                      confiabilidad y alta calidad.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001">
                      Cumplir con la normativa legal aplicable y los requisitos de nuestros clientes,
                      garantizando que nuestras actividades se desarrollen conforme a los
                      estándares establecidos.
                    </Typography>
                  </Box>
                  <Box display="flex">
                    <Box>
                      <CircleIcon
                        style={{ fontSize: "small", marginRight: "10px" }}
                      />
                    </Box>
                    <Typography className="TextPolitica9001">
                      Promover la mejora continua de nuestros procesos y la eficacia del Sistema
                      de Gestión de Calidad, mediante el análisis de resultados, auditorías internas
                      y revisión por la dirección.
                    </Typography>
                  </Box>
                </Box>
                <Box className="positiconversionandfecha">
                  <Typography>V.04</Typography>
                  <Typography>02/01/2026</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Politica9001;
